"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLowestLongStayDiscount = void 0;
const getLowestLongStayDiscount = (data, number_of_nights) => {
    // can you go through each rate and find the lowest long stay discount and return that whole object
    let lowestDiscount = null;
    if (data.length === 0)
        return null;
    data.forEach((item) => {
        if (item.discount?.long_stay_discounts) {
            if (item.discount.long_stay_discounts.length === 0)
                lowestDiscount = null;
            const filtered_discounts = item.discount.long_stay_discounts.filter((discount) => discount.min_nights <= number_of_nights);
            // with this filtered discounts, give me only the ones with the highest min_nights value
            const highestMinNights = Math.max(...filtered_discounts.map((discount) => discount.min_nights));
            // now that we have the highest min_nights value, filter out the discounts that have that value
            const highestMinNightsDiscounts = filtered_discounts.filter((discount) => discount.min_nights === highestMinNights);
            const discount_policy_percentage = lowestDiscount
                ? lowestDiscount.discount_percentage
                : 0;
            highestMinNightsDiscounts.forEach((discount) => {
                if (discount.discount_percentage <= discount_policy_percentage ||
                    !lowestDiscount) {
                    lowestDiscount = discount;
                }
            });
        }
    });
    return lowestDiscount;
};
exports.getLowestLongStayDiscount = getLowestLongStayDiscount;
